export const sanitizeSvgString = (svgString: string): string => {
  // use encodeURIComponent and unescape to handle non-Latin1 characters in SVG string
  return unescape(encodeURIComponent(svgString));
};
